var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TopBlock',{attrs:{"topData":_vm.topData}}),_c('OurProjects',{staticClass:"center"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }